


































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as SiteActionNames } from '@/store/modules/site/keys'
import { ActionNames as DetailedSiteActionNames } from '@/store/modules/site-detailed/keys'
import { ActionNames as UnitActionNames } from '@/store/modules/unit/keys'
import { GetterNames as SiteGetterNames } from '@/store/modules/site/keys'
import { GetterNames as DetailedSiteGetterNames } from '@/store/modules/site-detailed/keys'

import { FlatSite } from '@/store/modules/site/getters'
import { ActionNames } from '@/store/modules/patient-with-detailed-reports/keys'

const enum TableColumnHeaders {
  Id = 'ID',
  FirstName = 'First Name',
  LastName = 'Last Name',
  Room = 'Room',
  Enabled = 'Enabled',
  PackageId = 'Assigned Package',
}

const enum TableColumnProps {
  Id = 'id',
  FirstName = 'firstName',
  LastName = 'lastName',
  Room = 'roomNumber',
  Enabled = 'active',
  PackageId = 'assignedVibeId',
}

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: false,
      default: null,
    },
    unit: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      errorMessage: '',
      isInitialLoading: true,

      isSavingData: false,

      pccOrg: null,
      pccFacId: null,

      patientTableHeaders: [
        {
          text: 'ID',
          value: 'id',
          width: 100,
        },
        {
          text: 'First Name',
          value: 'firstName',
        },
        {
          text: 'Last Name',
          value: 'lastName',
        },
        {
          text: 'Room',
          value: 'roomNumber',
          width: 100,
        },
        {
          text: 'Enabled',
          value: 'active',
          width: 100,
        },
        {
          text: 'Package ID',
          value: 'assignedVibeId',
        },
      ].map(header => ({
        ...header,
        sortable: true,
        divider: true,
        // width: '16.6667%',
        width: header.width || '150',
        class: ['white--text', 'primary'],
        slotName: `item.${header.value}`,
      })),
      tableColumnHeaders: [
        TableColumnHeaders.Id,
        TableColumnHeaders.FirstName,
        TableColumnHeaders.LastName,
        TableColumnHeaders.Room,
        TableColumnHeaders.Enabled,
        TableColumnHeaders.PackageId,
      ],
      tableColumnProps: [
        TableColumnProps.Id,
        TableColumnProps.FirstName,
        TableColumnProps.LastName,
        TableColumnProps.Room,
        TableColumnProps.Enabled,
        TableColumnProps.PackageId,
      ],
    }
  },

  computed: {
    ...mapGetters(ModuleNames.site, {
      authorizedSites: `${SiteGetterNames.sites}`,
    }),
    ...mapGetters(ModuleNames.siteDetailed, {
      detailedSites: `${DetailedSiteGetterNames.detailedSites}`,
    }),
    patientsInUnit(): object[] {
      let _detailedSites = this.detailedSites
      console.log('detailedSites:', _detailedSites)
      let _detailedSite = _detailedSites.filter(s => s.id == this.site.id)
      console.log('detailedSite:', _detailedSite)
      return (_detailedSite.emrPatients || []).filter(p => p.unitId == this.unit.unitId)
    },
  },

  async mounted(): Promise<void> {
    await Promise.all([
      this[SiteActionNames.getSites](),
      this[DetailedSiteActionNames.getDetailedSiteById]({
        siteId: this.site.id,
      }),
    ])
    this.isInitialLoading = false
    let s = this.sites
    this.emitValidStatus()
  },

  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },
  methods: {
    ...mapActions(ModuleNames.site, [SiteActionNames.getSites]),
    ...mapActions(ModuleNames.unit, [UnitActionNames.patchUnit]),
    ...mapActions(ModuleNames.siteDetailed, [DetailedSiteActionNames.getDetailedSiteById]),

    unitDesc(val: any): string {
      return `${val.unitDesc}`
    },

    emitValidStatus() {
      this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: true,
      })
    },

    emitSite(_site) {
      this.$emit('update:site', _site)
    },

    unitSelected(e) {
      this.$nextTick(() => {
        // this.pccOrg = this.selectedSite.pccOrg
        // this.pccFacId = this.selectedSite.pccFacId
        // this.patientMonitoringEnabled = this.selectedSite.patientMonitoringEnabled
        // this.syncPatientsFromEmr = this.selectedSite.syncPatientsFromEmr
        // this.emitSite()
        this.emitValidStatus()
      })
    },

    async saveUnitDetails(withPackages) {
      console.log('saving unit details')
      this.isSavingData = true
      this.errorMessage = 'please wait...'
      try {
        var result = await this.patchUnitDetails(this.site.id, this.unit, withPackages)
        console.log('result: ')
        console.log(result)
        await this.updateSites()
        this.errorMessage = null
      } catch (e) {
        this.errorMessage = 'Failed to save unit details'
        console.error(e)
      }
      this.isSavingData = false
      // this.emitSite()
    },
    async patchUnitDetails(siteId, unit, withPackages) {
      console.log('patching... ')
      console.log(unit)
      return await this[UnitActionNames.patchUnit]({
        id: siteId + '~' + unit.unitId,
        attributes: {
          ...unit,
          siteId: siteId,
          patients: this.patientsInUnit,
          withPackages: withPackages,
        },
      })
    },
    async updateSites() {
      try {
        await Promise.all([this[SiteActionNames.getSites]()])
        let _sites = this.authorizedSites
        let _site = _sites.filter(s => s.id == this.site.id)
        if (_site && _site.length > 0) {
          this.emitSite(_site[0])
        }
      } catch (e) {
        this.errorMessage = 'Failed to refresh details'
        console.error(e)
      }
    },
  },
}
